import ApiBase from './ApiBase';
import axios from 'axios';
import { getManyByChunk } from '../utils';
import { stringify } from '../components/forked/stringify';

/**
 * FundInvestor API
 */
class FundInvestorApi extends ApiBase {
  /**
   * create fundInvestors
   * @param {*} fundInvestors
   */
  async create(fundInvestors) {
    const request = {
      url: `${this.API_URL}/fundinvestors`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(fundInvestors)
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Get related funds in excel
   * @param investorId
   * @param {*} filters
   */
  async getRelatedFundsAsExcel(investorId, filters) {
    const queryParameters = stringify(
      {
        investorId: investorId,
        fundName: filters.fundName,
        fundId: filters.fundId,
        fundInvestorTagId: filters.fundInvestorTagId
      },
      {
        arrayFormat: 'open-ic'
      }
    );
    const request = {
      url: `${this.API_URL}/fundinvestor/excel/export?${queryParameters}`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob'
    };

    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async get(fundId, investorId, shouldReturnTags) {
    const request = {
      url: `${this.API_URL}/fundinvestor?fundId=${fundId}&investorId=${investorId}&returnFundInvestorTags=${shouldReturnTags}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }

  async getByInvestorId(investorId) {
    const request = {
      url: `${this.API_URL}/fundinvestors?investorId=${investorId}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }

  async update(fundId, investorId, fundInvestor) {
    const request = {
      url: `${this.API_URL}/fundinvestor?fundId=${fundId}&investorId=${investorId}`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: JSON.stringify(fundInvestor)
    };

    const response = await axios.request(request);

    return response.data;
  }

  async delete(fundInvestor) {
    const request = {
      url: `${this.API_URL}/fundinvestors`,
      headers: this.getHeaders(),
      method: 'DELETE',
      data: JSON.stringify(fundInvestor)
    };

    const response = await axios.request(request);

    return response.data;
  }

  async getByFundIds(fundIds, paramsMaxSize) {
    const baseUrl = `${this.API_URL}/fundinvestors?fundId=`;
    let encodedReqIds = encodeURI(`${fundIds}`);

    return getManyByChunk(baseUrl, encodedReqIds, paramsMaxSize);
  }
}

export default new FundInvestorApi();
